<template>
  <div class="home">
    <div class="top-info">
        Welcome {{ firstName }}
        <b>Student No: {{ student_number }}</b>
        <span class="inst-name-mobile">{{ company.company_name }}</span>  
    </div>
    <div class="row">
      <div class="col-md-12">

        <router-link to="/classroom">
          <div class="top-message">
            <span
              class="new-icons icon-presentation"
              style="margin-right: 10px;"
            ></span>
            Live Class rooms
          </div>
        </router-link>
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide"
                  ><i class="la la-gear"></i
                ></span>
                <h3 class="m-portlet__head-text">Dashboard</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <div class="dash-page">
                  <!--
                  <div class="row">
                    <div class="col-md-12">
                      <nav class="navbar navbar-expand-lg navbar-light top-filter">
                        <div class="collapse navbar-collapse"  id="navbarSupportedContent">
                          <ul class="navbar-nav mr-auto">
                            <li class="nav-item active">
                              <a class="nav-link" href="#"
                                >All Courses
                                <span class="sr-only">(current)</span></a
                              >
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#">JAVA Programming</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" href="#"
                                >Web Design & Development</a
                              >
                            </li>
                          </ul>
                        </div>
                      </nav>
                    </div>
                  </div>-->
                  <div class="row" v-if="!newshide">
                      <div class="col-md-12" v-if="notice">
                          <div class="news-area" v-bind:style="{ background: notice.bg_color}">
                              <div class="close-news" v-on:click="newshide = true">
                                  <img src="images/close.png" />
                              </div>
                              <div class="content hideContent" v-html="notice.notice">
                              </div>
                              <div class="show-more">
                                <a class="action-button" v-if="!readMoreActivated" @click="activateReadMore" href="#">
                                    Read more...
                                </a>
                                <a class="action-button" v-if="readMoreActivated" @click="inactivateReadMore" href="#">
                                    Read less
                                </a>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 padding-r-7">
                      <div class="card">
                        <div class="card-body">
                          <div class="card classroom">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <h3>Next Live Classroom</h3>
                                  <div class="tim">
                                    {{ nextClass.days }}<span>Days</span>
                                  </div>
                                  <div class="tim">
                                    {{ nextClass.h }}<span>Hours</span>
                                  </div>
                                  <div class="tim">
                                    {{ nextClass.i }}<span>Mins</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="all-course">
                            <div v-if="courses">
                              <div v-for="(item, index) in courses.courses" :key="index" class="card courses">
                                <div class="card-body">
                                  <!-- <div class="profiles">
                                  <img src="images/profile.png" />
                                </div> -->
                                  <H3>{{ item.name }}</H3>
                                  <p>End Date {{ item.end_date_string }}</p>
                                  <div class="row">
                                    <div class="col-md-6 text-left">
                                      <span>Progress</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                      <span>{{ item.course_progress }}%</span>
                                    </div>
                                  </div>
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" :style="'width: ' + item.course_progress + '%'" :aria-valuenow="item.course_progress" aria-valuemin="0" aria-valuemax="100">
                                      {{ item.course_progress }}%
                                    </div>
                                  </div>
                                  <ul class="list-group list-group-flush">
                                    <div
                                      v-for="(payment, x) in item.payments"
                                      class="pay-list"
                                      :key="x"
                                    >
                                      <li
                                        v-if="
                                          (payment.is_due &&
                                            payment.status === 'pending') ||
                                            payment.status === 'partial'
                                        "
                                        class="list-group-item"
                                      >
                                        inst {{ payment.installment_no }} -
                                        {{ currency.symbol }}
                                        {{
                                          numberWithCommas(
                                            payment.outstanding_amount
                                          )
                                        }}<sup>{{ currency.code }}</sup>
                                        <b class="due"
                                          >{{ payment.due_days }} Days Due</b
                                        >
                                      </li>
                                    </div>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="no-data" v-else>
                              <img src="images/no-data.jpg" />
                              <p>No Data Available</p>
                              <span>Try something else</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9 padding-l-7">
                      <div class="row">
                        <div class="col-md-4 padding-r-7">
                          <div class="card stat-card orange">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="icon-head">
                                    <img src="images/book.png" />
                                  </div>
                                  <div class="top-h">
                                    <h3>Courses</h3>
                                    <p>About Courses</p>
                                  </div>
                                </div>
                                <div class="col-md-8"></div>
                              </div>
                            </div>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                <b>{{ inprogress }}</b> In Progress
                              </li>
                              <li class="list-group-item">
                                <b>{{ completed }}</b> Completed
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="col-md-4 padding-l-7 padding-r-7">
                          <div class="card stat-card grey">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="icon-head">
                                    <img src="images/class.png" />
                                  </div>
                                  <div class="top-h">
                                    <h3>Live Classes</h3>
                                    <p>About Classes</p>
                                  </div>
                                </div>
                                <div class="col-md-8"></div>
                              </div>
                            </div>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                <b>{{ upCommingClass }}</b> Upcoming Classes
                              </li>
                              <li class="list-group-item">
                                <b>{{ passClass }}</b> Previous Classes
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="col-md-4 padding-l-7">
                          <div class="card stat-card pay">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="icon-head">
                                    <img src="images/payment.png" />
                                  </div>
                                  <div
                                    class="top-h"
                                    style="width: 56%; font-size: 1.2rem;"
                                  >
                                    <h3 style="font-size: 1.2rem;">Payment</h3>
                                    <p>Summary</p>
                                  </div>
                                </div>
                                <div class="col-md-8"></div>
                              </div>
                            </div>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                <b>{{ overdueTerms }}</b>
                                Overdue Terms
                                <div class="amount-pay due">
                                  <span>{{ currency.symbol }} {{ numberWithCommas(overdue)}}<sup>{{ currency.code }}</sup></span>
                                </div>
                              </li>
                              <li class="list-group-item">
                                <b>{{ finishedTerms }}</b>
                                Paid Terms
                                <div class="amount-pay paid">
                                  <span
                                    >{{ currency.symboole
                                    }}{{ currency.symbol }}
                                    {{ numberWithCommas(paid)
                                    }}<sup>{{ currency.code }}</sup></span
                                  >
                                </div>
                              </li>
                              <li class="list-group-item">
                                <b>{{ pending_terms }}</b>
                                Future Terms
                                <div class="amount-pay future">
                                  <span
                                    >{{ currency.symboole
                                    }}{{ currency.symbol }}
                                    {{ numberWithCommas(pending)
                                    }}<sup>{{ currency.code }}</sup></span
                                  >
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="chart-main">
                            <div class="left">
                              <h3>Assignment Status</h3>
                              <div class="inner-chart text-center">
                                <div class="no-data">
                                  <img src="images/no-data.jpg" />
                                  <p>No Data Available</p>
                                </div>
                                <!-- <apexchart
                                  :options="chartOptions"
                                  :series="series"
                                ></apexchart> -->
                              </div>
                            </div>
                            <div class="right">
                              <h3>Quiz Completion</h3>
                              <div class="inner-dount text-center">
                                <div class="no-data">
                                  <img src="images/no-data.jpg" />
                                  <p>No Data Available</p>
                                </div>
                                <!-- <apexchart
                                  :options="chartOptions2"
                                  :series="series2"
                                ></apexchart> -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--
                        <div class="col-md-4 padding-l-7">
                          <div class="noti">
                            <div class="card">
                              <div class="card-header">
                                <div class="icon-n">
                                  <img src="images/bell.png" />
                                </div>
                                <h3>Notification</h3>
                              </div>
                              <div class="card-body">
                                <ul class="list-group list-group-flush">
                                  <li class="list-group-item">
                                    <div class="no-icon">
                                      <img src="images/book.png" />
                                    </div>
                                    <div class="desc">
                                      <p>Updated a New Assignment</p>
                                      <span>12th March 2021</span>
                                    </div>
                                  </li>
                                  <li class="list-group-item">
                                    <div class="no-icon">
                                      <img src="images/book.png" />
                                    </div>
                                    <div class="desc">
                                      <p>Updated a New Assignment</p>
                                      <span>12th March 2021</span>
                                    </div>
                                  </li>
                                  <li class="list-group-item">
                                    <div class="no-icon">
                                      <img src="images/book.png" />
                                    </div>
                                    <div class="desc">
                                      <p>Updated a New Assignment</p>
                                      <span>12th March 2021</span>
                                    </div>
                                  </li>
                                  <li class="list-group-item">
                                    <div class="no-icon">
                                      <img src="images/book.png" />
                                    </div>
                                    <div class="desc">
                                      <p>Updated a New Assignment</p>
                                      <span>12th March 2021</span>
                                    </div>
                                  </li>
                                  <li class="list-group-item">
                                    <div class="no-icon">
                                      <img src="images/book.png" />
                                    </div>
                                    <div class="desc">
                                      <p>Updated a New Assignment</p>
                                      <span>12th March 2021</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>

<script>
var Config = require('../router/Config')
// var $ = require('jquery')
var Cookies = require('vue-cookies')

module.exports = {
  name: 'dashboard',
  components: {},
  data () {
    return {
      firstName: '',
      student_number: '',
      company: [],
      newshide: false,
      readMoreActivated: false,
      longText: "",
      upCommingClass: 0,
      pending_terms: 0,
      courses: [],
      overdueTerms: 0,
      overdue: 0,
      paid: 0,
      pending: 0,
      finishedTerms: 0,
      passClass: 0,
      inprogress: 0,
      completed: 0,
      nextClass: [],
      notice: [],
      currency: [],
      msg: 'Welcome to Your Vue.js App',
      series: [
        {
          name: 'Web2021',
          data: [30, 40, 65]
        },
        {
          name: 'php2021',
          data: [10, 80, 95]
        },
        {
          name: 'java2021',
          data: [60, 30, 100]
        }
      ],
      series2: [44, 55, 41],
      stroke: {
        curve: 'smooth'
      },
      chartOptions: {
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '11px',
          fontWeight: 500,
          floating: false,
          offsetY: 5
        },
        chart: {
          height: 30,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 10,
            left: 7,
            blur: 10,
            opacity: 0.1
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#a113c5', '#fb026b', '#43df1f'],
        xaxis: {
          categories: ['Assignment 1', 'Assignment 2', 'Assignment 3']
        },
        yaxis: {
          title: {
            text: 'Marks %'
          },
          min: 0,
          max: 100
        }
      },
      chartOptions2: {
        labels: ['java2021', 'php2021', 'web2021'],
        chart: {
          type: 'donut',
          height: '100',
          width: '100px'
        },
        colors: ['#a113c5', '#fb026b', '#43df1f'],
        responsive: [
          {
            breakpoint: 480,
            options: {}
          }
        ],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '11px',
          fontWeight: 500,
          floating: false,
          offsetY: -10
        }
      }
    }
  },
  mounted () {
    this.getData()
    this.firstName = Cookies.get('firstName')
    this.student_number = Cookies.get('student_number')
    this.company = Cookies.get('company')
  },
  methods: {
    getData: function () {
      this.axios
        .get(
          Config.API_URL +
            '/api/fe/student/dashboard/' +
            Cookies.get('userId') +
            '/' +
            Cookies.get('studentId') +
            '/' +
            Cookies.get('clientId') +
            '?token=' +
            Cookies.get('accessToken')
        )
        .then(response => {
          console.log(response.data)
          this.upCommingClass = response.data.upcommingClass
          this.passClass = response.data.passschedule
          this.overdueTerms = response.data.overdue_terms
          this.finishedTerms = response.data.finished_terms
          this.overdue = response.data.overdue
          this.paid = response.data.paid
          this.pending = response.data.pending
          this.courses = response.data.courses
          this.nextClass = response.data.next_classroom
          this.inprogress = response.data.inprogress
          this.completed = response.data.completed
          this.pending_terms = response.data.pending_terms
          this.currency = response.data.currency
          this.notice = response.data.notice
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    activateReadMore () {
      this.readMoreActivated = true
      $('.content').removeClass('hideContent')
    },
    inactivateReadMore () {
      this.readMoreActivated = false
      $('.content').addClass('hideContent')
    }

  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/component/dashboard/dashboard';
</style>
